import React from 'react';
import { Box } from '../../../base/Box/Box';
import { Type } from '../../../base/Type/Type';

type Props = {
  filterState: object;
  setOpen: (open: string) => void;
  setFilterState: (filter: object) => void;
};

const filterIsSet = (filterState: object) =>
  Object.keys(filterState).length !== 0;

export const Label = ({ filterState, setOpen, setFilterState }: Props) => (
  <Box as="div" className="flex items-center justify-between px-2 mb-1">
    <Type as="p" className="text-left font-foundersGrotesk text-p1">
      Filter by
    </Type>
    {filterIsSet(filterState) && (
      <Type
        as="span"
        role="button"
        className="text-ffMidGrey font-foundersGrotesk underline cursor-pointer"
        onClick={() => {
          setOpen('');
          setFilterState({});
        }}
      >
        Clear
      </Type>
    )}
  </Box>
);
